import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Category, URL_KEY } from './consts';
import InsightsList from './components/InsightsList';
import Skeletons from './components/Skeletons';
import InsightsErrorBoundary from './components/InsightsErrorBoundary';
import { CreativeInsightsEmptyState } from '../../../components/pages/reports/emptyStates/CreativeInsightsEmptyState';
import TutorialSteps from '../../../components/utilities/tutorialSteps/TutorialSteps';
import NoInsightsIcon from '../../../resources/icons/creatives/noinsights.svg';

export const NO_DATA_PARAMS = {
    icon: <NoInsightsIcon />,
    title: 'STATIC.PAGES.CREATIVE_INSIGHTS.NO_DATA.TITLE',
    steps: [...Array(3)].map((_, index) => `STATIC.PAGES.CREATIVE_INSIGHTS.NO_DATA.STEPS.${index + 1}`),
};

const CreativeInsightsTabContent = ({
    insights,
    isLoading,
    onExpandSection = null,
    app,
    source,
    onInsightsDataReady,
}) => {
    const [expandedCategory, setExpandedCategory] = useState();
    const [briefs, setBriefs] = useState(null);
    const [allInsights, setAllInsights] = useState(null);
    const [suggestions, setSuggestions] = useState(null);

    useEffect(() => {
        if (!insights) {
            setAllInsights(null);
            return;
        }

        setBriefs(insights[Category.CREATIVE_BRIEF]);

        const suggestionsData = insights[Category.SUGGESTIONS];
        setSuggestions(suggestionsData);

        const filteredInsights = Object.fromEntries(
            Object.entries(insights).filter(
                ([title]) => ![Category.CREATIVE_BRIEF, Category.SUGGESTIONS, URL_KEY].includes(title)
            )
        );

        setAllInsights(filteredInsights);

        onInsightsDataReady(insights[URL_KEY] || null);
    }, [insights]);

    const onCategoryClick = category => {
        const isExpanding = expandedCategory !== category;

        if (isExpanding) {
            onExpandSection(category);
        }

        setExpandedCategory(isExpanding ? category : null);
    };

    const renderTabContent = () => {
        if (!app || !source) {
            return <CreativeInsightsEmptyState />;
        }
        if (isLoading !== false) {
            return <Skeletons />;
        }

        if (!allInsights) {
            return <TutorialSteps {...NO_DATA_PARAMS} />;
        }

        return (
            <InsightsList
                allInsights={allInsights}
                suggestions={suggestions}
                expandedCategory={expandedCategory}
                onCategoryClick={onCategoryClick}
                briefs={briefs}
            />
        );
    };
    return renderTabContent();
};

CreativeInsightsTabContent.propTypes = {
    insights: PropTypes.shape({}),
    isLoading: PropTypes.bool,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    onExpandSection: PropTypes.func,
    app: PropTypes.string,
    source: PropTypes.string,
    onInsightsDataReady: PropTypes.func,
};

const CreativeInsightsTab = props => (
    <InsightsErrorBoundary>
        <CreativeInsightsTabContent {...props} />
    </InsightsErrorBoundary>
);

export default CreativeInsightsTab;
